// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host .header {
  height: 38px;
  background-color: var(--ion-color-secondary);
  border-radius: 0 0 50% 50%;
}
:host ion-avatar {
  margin: 40px auto !important;
  z-index: 999;
}
:host h4 {
  color: var(--ion-color-primary);
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-profile2/custom-profile2.component.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,4CAAA;EACA,0BAAA;AAAJ;AAGE;EACE,4BAAA;EACA,YAAA;AADJ;AAGE;EACE,+BAAA;AADJ","sourcesContent":[":host {\n  .header {\n    height: 38px;\n    background-color: var(--ion-color-secondary);\n    border-radius: 0 0 50% 50%;\n  }\n\n  ion-avatar {\n    margin: 40px auto !important;\n    z-index: 999;\n  }\n  h4{\n    color: var(--ion-color-primary);\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
